<template>
  <div>
    <van-cell-group class="form-setion">
      <van-field v-model="account" label="会员账号：" readonly />
      <van-field v-model="price" type="digit" label="充值金额：" />
    </van-cell-group>

    <van-radio-group v-model="payStyleRadio">
      <van-cell-group title="请选择支付方式">
        <van-cell clickable @click="payStyleRadio = '1'">
          <van-radio slot="right-icon" name="1" />
          <template slot="title">
            <div class="paystyle-list">
              <img src="@/assets/images/me/ic_pay_wechat.png" />
              <div class="flexmid">
                <p class="tit">微信支付</p>
              </div>
            </div>
          </template>
        </van-cell>
        <!-- <van-cell clickable @click="payStyleRadio = '2'">
          <van-radio slot="right-icon" name="2" />
          <template slot="title">
            <div class="paystyle-list">
              <img src="@/assets/images/me/ic_pay_alipay.png" />
              <div class="flexmid">
                <p class="tit">支付宝支付</p>
              </div>
            </div>
          </template>
        </van-cell>-->
      </van-cell-group>
    </van-radio-group>

    <div class="btn-area">
      <van-button @click="onPay" class="mybtn" type="info" size="large">确认支付</van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Toast } from "vant";
export default {
  data() {
    return {
      account: "",
      price: "100",
      options: {
        type: "WeiXinPay"
      },
      payStyleRadio: "1" //1为微信,2为支付宝
    };
  },
  computed: {
    ...mapGetters(["currentMember"])
  },
  mounted() {
    this.account = this.currentMember.No;
  },
  methods: {
    onPay() {
      console.log(this.payStyleRadio);
      if (this.payStyleRadio == 1) {
        this.WeixinPay();
      } else {
        this.AliPay();
      }
    },
    WeixinPay() {
      var that = this;
      var _openId = sessionStorage.getItem("OpenId");
      console.log("使用微信支付");

      if (!/\d+/.test(that.price)) {
        Toast("请输入正确金额再进行支付！");
        return false;
      }

      Object.assign(that.options, {
        price: that.price,
        openid: _openId
      });
      that.$store.dispatch(that.options).then(
        res => {
          console.log(res);
          that.$weixin.weiXinPay(res,function(){
              Toast("已支付成功！");
              that.$router.go(-1);
          },function(){
            
          });
        },
        error => {}
      );
    },
    AliPay() {
      console.log("使用支付宝支付");
    },
    getMember() {
      var _options = {
        type: "GetMemberIndex"
      };
      this.$store.dispatch(_options);
    }
  }
};
</script>

<style scoped>
.form-setion {
  margin: 20px 0 20px;
}
.paystyle-list {
  display: flex;
  align-items: center;
}
.paystyle-list img {
  width: 32px;
  height: 32px;
  margin-right: 15px;
}
.paystyle-list .tit {
  font-size: 15px;
}
.paystyle-list .des {
  font-size: 12px;
  color: #999;
}
.paystyle-list .payDisableIcon {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: auto;
  margin: 0;
}
.payPackage-list {
  display: flex;
  align-items: center;
}
.payPackage-list > .name {
  font-size: 14px;
  color: orange;
  flex: 1;
}
.payPackage-list > .bd {
  flex: 2;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.payPackage-list img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 10px;
}
.payPackage-list .num {
  font-size: 14px;
  color: orange;
}
</style>